import { TypedMatNode } from "../_Base";
import { BaseController } from "./_BaseController";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { NoBlending, NormalBlending, AdditiveBlending, SubtractiveBlending, MultiplyBlending } from "three";
import { updateMaterialSide } from "./helpers/MaterialSideHelper";
const BLENDING_VALUES = {
  NoBlending,
  NormalBlending,
  AdditiveBlending,
  SubtractiveBlending,
  MultiplyBlending
};
const BLENDING_VALUE_NAMES = Object.keys(BLENDING_VALUES);
export function AdvancedCommonParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.doubleSided = ParamConfig.BOOLEAN(0);
      this.front = ParamConfig.BOOLEAN(1, { visibleIf: { doubleSided: false } });
      this.overrideShadowSide = ParamConfig.BOOLEAN(0);
      this.shadowDoubleSided = ParamConfig.BOOLEAN(0, { visibleIf: { overrideShadowSide: true } });
      this.shadowFront = ParamConfig.BOOLEAN(1, { visibleIf: { overrideShadowSide: true, shadowDoubleSided: false } });
      this.colorWrite = ParamConfig.BOOLEAN(1, {
        separatorBefore: true,
        cook: false,
        callback: (node, param) => {
          AdvancedCommonController.update(node);
        }
      });
      this.depthWrite = ParamConfig.BOOLEAN(1, {
        cook: false,
        callback: (node, param) => {
          AdvancedCommonController.update(node);
        }
      });
      this.depthTest = ParamConfig.BOOLEAN(1, {
        cook: false,
        callback: (node, param) => {
          AdvancedCommonController.update(node);
        }
      });
      this.premultipliedAlpha = ParamConfig.BOOLEAN(false, {
        separatorAfter: true
      });
      this.blending = ParamConfig.INTEGER(NormalBlending, {
        menu: {
          entries: BLENDING_VALUE_NAMES.map((name) => {
            return { name, value: BLENDING_VALUES[name] };
          })
        }
      });
      this.dithering = ParamConfig.BOOLEAN(0);
      this.polygonOffset = ParamConfig.BOOLEAN(false, { separatorBefore: true });
      this.polygonOffsetFactor = ParamConfig.INTEGER(0, { range: [0, 1e3], visibleIf: { polygonOffset: 1 } });
      this.polygonOffsetUnits = ParamConfig.INTEGER(0, { range: [0, 1e3], visibleIf: { polygonOffset: 1 } });
    }
  };
}
class AdvancedCommonParamsConfig extends AdvancedCommonParamConfig(NodeParamsConfig) {
}
class AdvancedCommonMapMatNode extends TypedMatNode {
}
export class AdvancedCommonController extends BaseController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  initializeNode() {
  }
  async update() {
    const mat = this.node.material;
    const pv = this.node.pv;
    this._updateSides(mat, pv);
    mat.colorWrite = pv.colorWrite;
    mat.depthWrite = pv.depthWrite;
    mat.depthTest = pv.depthTest;
    mat.blending = pv.blending;
    mat.premultipliedAlpha = pv.premultipliedAlpha;
    mat.dithering = pv.dithering;
    mat.polygonOffset = pv.polygonOffset;
    if (mat.polygonOffset) {
      mat.polygonOffsetFactor = pv.polygonOffsetFactor;
      mat.polygonOffsetUnits = pv.polygonOffsetUnits;
      mat.needsUpdate = true;
    }
  }
  _updateSides(mat, pv) {
    updateMaterialSide(mat, pv);
  }
  static async update(node) {
    node.controllers.advancedCommon.update();
  }
}
